/**
 * Site Refresh 2026: homepage scrolling strip (A16). Markup: snippets/refresh-strip.liquid.
 *
 * The track holds the texts four times; it moves ~30px/s and wraps by the width of one set, so
 * there is no jump. It stops while Pause is pressed, while the pointer is over the strip, while
 * the Pause button has keyboard focus, off-screen and in a hidden tab. prefers-reduced-motion:
 * no movement (the CSS also hides the button).
 */
(() => {
	if (window.__rstripInit) return;
	window.__rstripInit = true;

	const SPEED = 30; // px per second
	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

	function init(root) {
		if (root.__rstrip) return;
		root.__rstrip = true;
		const track = root.querySelector('.js-rstrip-track');
		const set = root.querySelector('.js-rstrip-set');
		const btn = root.querySelector('.js-rstrip-pause');
		if (!track || !set) return;
		const dir = parseFloat(root.getAttribute('data-rstrip-dir')) || -1;
		const labels = { pause: root.getAttribute('data-rstrip-pause'), play: root.getAttribute('data-rstrip-play') };

		let width = 0;
		let pos = 0;
		let last = 0;
		let raf = 0;
		let paused = false;
		let hover = false;
		let focus = false;
		let visible = false;

		const measure = () => { width = set.getBoundingClientRect().width; };
		const running = () => !paused && !hover && !focus && visible && !reduced.matches && !document.hidden && width > 0;

		function draw() {
			const x = dir < 0 ? -pos : pos - width;
			track.style.transform = `translate3d(${x}px, 0, 0)`;
		}

		function frame(now) {
			raf = 0;
			if (!running()) { last = 0; return; }
			const dt = last ? Math.min((now - last) / 1000, 0.1) : 0;
			last = now;
			pos = (pos + SPEED * dt) % width;
			draw();
			raf = requestAnimationFrame(frame);
		}

		function tick() {
			if (running()) {
				if (!raf) { last = 0; raf = requestAnimationFrame(frame); }
			} else if (raf) {
				cancelAnimationFrame(raf);
				raf = 0;
				last = 0;
			}
		}

		if (btn) {
			btn.addEventListener('click', () => {
				paused = !paused;
				btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
				btn.setAttribute('aria-label', paused ? labels.play : labels.pause);
				tick();
			});
			btn.addEventListener('focus', () => { if (btn.matches(':focus-visible')) { focus = true; tick(); } });
			btn.addEventListener('blur', () => { focus = false; tick(); });
		}
		root.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { hover = true; tick(); } });
		root.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { hover = false; tick(); } });

		if ('IntersectionObserver' in window) {
			new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; tick(); }).observe(root);
		} else {
			visible = true;
		}
		document.addEventListener('visibilitychange', tick);
		reduced.addEventListener('change', () => { if (reduced.matches) track.style.transform = ''; else draw(); tick(); });
		window.addEventListener('resize', () => { measure(); pos = width ? pos % width : 0; if (!reduced.matches) draw(); });
		if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { measure(); if (!reduced.matches) draw(); tick(); });

		measure();
		if (!reduced.matches) draw();
		tick();
	}

	function initAll() { document.querySelectorAll('[data-rstrip]').forEach(init); }
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
	else initAll();
	document.addEventListener('shopify:section:load', initAll);
})();
